module.exports = __webpack_public_path__ + "static/img/title_02.124aca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_02.png
// module id = Xe5R
// module chunks = 1